export const ENDPOINT = "/requirements";
